import * as stylex from '@stylexjs/stylex';
import '../styles/tokens.stylex';
import { spacing } from '../styles/tokens.stylex';
import { typography } from '../styles/typography';
import { PageSectionsContentSectionContentBlocksStatBar } from '@/tina/__generated__/types';
import { tinaField } from 'tinacms/dist/react';
export interface StatBarProps {
  data: PageSectionsContentSectionContentBlocksStatBar;
}
export function StatBar({
  data,
  ...props
}: StatBarProps) {
  return data ? <ul className="x1ghz6dp x1717udv xe8uvvx xrvj5dj x1mhrlx8 xzfn7dr x11qjcnl x16m2cjf x1nwz1zu" {...props}>
      {data.stat.map((stat, i) => <li className="x1ghz6dp x1717udv" key={`${i}-${stat.context.replace(' ', '')}`}>
          {stat.metric && <h2 {...stylex.props([typography.heading1])} data-tina-field={tinaField(stat, 'metric')}>
              {stat.metric}
            </h2>}
          {stat.context && <p {...stylex.props([typography.body, localStyles.description])} data-tina-field={tinaField(stat, 'context')}>
              {stat.context}
            </p>}
        </li>)}
    </ul> : null;
}
const localStyles = {
  description: {
    kN2L0X: "x1fzhlzt",
    $$css: true
  }
};